import clsx from 'clsx';
import { HTMLAttributes } from 'react';

import './view.scss';

export interface ViewProps extends HTMLAttributes<HTMLDivElement> {
	showBackgroundLogo?: boolean;
}

const View: React.FunctionComponent<ViewProps> = ({ showBackgroundLogo = true, className, children }) => {
	return (
		<div className={clsx('view', className)}>
			{children}
		</div>
	);
};

export default View;
